// Generic helper to unwrap API envelope produced by backend ResponseHelper
// Backend shape: { success, data: <payload>, error, meta }
// Returns the inner payload (data) if envelope detected, otherwise the original value.
export function unwrapEnvelope(raw) {
  if (!raw || typeof raw !== 'object') return raw;
  if ('success' in raw && 'data' in raw && (raw.meta || raw.error !== undefined)) {
    return raw.data;
  }
  return raw;
}

// Convenience helpers for common paged result shapes (Items/Total or items/total)
export function unwrapPaged(raw) {
  const payload = unwrapEnvelope(raw);
  if (!payload || typeof payload !== 'object') return { items: Array.isArray(payload) ? payload : [], total: Array.isArray(payload) ? payload.length : 0 };
  if (Array.isArray(payload)) return { items: payload, total: payload.length };
  const items = payload.items || payload.Items || [];
  const total = payload.total ?? payload.Total ?? (Array.isArray(items) ? items.length : 0);
  return { items: Array.isArray(items) ? items : [], total };
}
